// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import BANK_TRACKING from 'consts/bankTrackingConsts';

const EXPERIMENT_STRIDE_TRANSITION = {
  experimentName: 'fullstack_stride_transition',
  variants: {
    control: 'control',
    stride: 'stride',
  },
};

export default {
  5: state => {
    const newState = produce(state, draft => {
      draft.enrollment = draft.enrollment || {};
      const { experimentName, variants } = EXPERIMENT_STRIDE_TRANSITION;
      const { experiments } = state;

      if (experiments && experiments[experimentName]) {
        const variant = experiments[experimentName];

        let bank = null;
        if (variant === variants.stride)
          bank = BANK_TRACKING.stride.bank_variant;
        else if (variant === variants.bancorp)
          bank = BANK_TRACKING.bancorp.bank_variant;

        draft.enrollment.bank = bank;
      }
    });

    return newState;
  },
};
